"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteReviewRequestSchema = exports.DeleteReviewResources = exports.RepublishReviewRequestSchema = exports.RepublishReviewResources = exports.MyReviewListPageRequestSchema = exports.MyReviewListPageQuery = void 0;
var zod_1 = require("zod");
var constants_1 = require("../constants");
exports.MyReviewListPageQuery = zod_1.z.object({
    /** 서비스 카테고리 */
    category: zod_1.z
        .union([
        zod_1.z.literal(constants_1.CATEGORY_KEYS.DOMESTIC),
        zod_1.z.literal(constants_1.CATEGORY_KEYS.LEISURE),
        zod_1.z.literal(constants_1.CATEGORY_KEYS.TNA_TOUR_TICKET),
    ])
        .optional(),
    /** 페이지 번호 */
    page: zod_1.z.number().optional(),
});
exports.MyReviewListPageRequestSchema = zod_1.z.object({
    query: exports.MyReviewListPageQuery,
});
exports.RepublishReviewResources = zod_1.z.object({
    /** 후기 ID */
    reviewId: zod_1.z.union([zod_1.z.number(), zod_1.z.string()]),
});
exports.RepublishReviewRequestSchema = zod_1.z.object({
    resources: exports.RepublishReviewResources,
});
exports.DeleteReviewResources = zod_1.z.object({
    /** 후기 ID */
    reviewId: zod_1.z.union([zod_1.z.number(), zod_1.z.string()]),
});
exports.DeleteReviewRequestSchema = zod_1.z.object({
    resources: exports.DeleteReviewResources,
});
